import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b6ade9f6")

_pushScopeId("data-v-b6ade9f6")
const _hoisted_1 = { class: "box shadow margin-b" }
const _hoisted_2 = { class: "media" }
const _hoisted_3 = { class: "media-content" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "columns is-mobile height-100 full-width is-vcentered" }
const _hoisted_6 = { class: "column is-3 is-flex is-horizontal-center" }
const _hoisted_7 = { class: "image is-64x64 margin-auto is-vcentered" }
const _hoisted_8 = { class: "column" }
const _hoisted_9 = { class: "is-text-white" }
const _hoisted_10 = { class: "margin-top" }
const _hoisted_11 = {
  key: 0,
  class: "text-overflow is-text-white"
}
const _hoisted_12 = {
  key: 1,
  class: "text-overflow has-text-grey"
}
const _hoisted_13 = { class: "level is-right is-mobile full-width" }
const _hoisted_14 = { class: "float-left display-inherit" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", {
  class: "tag is-dark",
  "data-testid": "ctf-text-thisisyou"
}, " This is you ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.user.username == _ctx.username)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: "/profile",
          "data-testid": "ctf-link-profile"
        }, {
          default: _withId(() => [
            _createVNode("article", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, [
                    _createVNode("div", _hoisted_6, [
                      _createVNode("figure", _hoisted_7, [
                        _createVNode("img", {
                          src: _ctx.imageUrl,
                          alt: "Image",
                          class: "is-rounded"
                        }, null, 8, ["src"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_8, [
                      _createVNode("strong", _hoisted_9, _toDisplayString(_ctx.username), 1),
                      _createVNode("div", _hoisted_10, [
                        _createVNode("span", {
                          class: 'tag is-' + _ctx.colorLevel
                        }, _toDisplayString(_ctx.computedLevel), 3)
                      ])
                    ])
                  ]),
                  (_ctx.description)
                    ? (_openBlock(), _createBlock("div", _hoisted_11, _toDisplayString(_ctx.description), 1))
                    : (_openBlock(), _createBlock("div", _hoisted_12, " No description yet "))
                ]),
                _createVNode("div", null, [
                  _createVNode("nav", _hoisted_13, [
                    _createVNode("div", _hoisted_14, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.language.slice(0, 2), (l) => {
                        return (_openBlock(), _createBlock("figure", {
                          key: l,
                          class: "image is-16x16 margin-r-10"
                        }, [
                          _createVNode("img", {
                            class: "is-rounded ",
                            src: `/img/flag-country/${l}.png`
                          }, null, 8, ["src"])
                        ]))
                      }), 128)),
                      (!_ctx.tagLoading && _ctx.skills.length > 0)
                        ? (_openBlock(), _createBlock("div", {
                            key: 0,
                            class: "custom-tag",
                            style: { backgroundColor: _ctx.findTagColor(_ctx.skills[0]) },
                            "data-testid": "ctf-text-thisisyou"
                          }, _toDisplayString(_ctx.skills[0]), 5))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_15
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
})